import { render } from "./TopLayout.vue?vue&type=template&id=6f9667aa"
import script from "./TopLayout.vue?vue&type=script&lang=js"
export * from "./TopLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__